import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function getItems(data) {
  return Axios({
    url: `${baseUrl()}/category/${data.id}/items`,
    method: "GET",
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
